/** A load label of an operation (PB-5281), owned by ms-org-manager. */
export interface OperationLabel {
  id?: string;
  operationId?: string;
  name: string;
  color: string;
  active: boolean;
  deleted?: boolean;
  /** Loads the label is on; only returned by the Operations page request. */
  usageCount?: number | null;
}

export interface OperationLabelSyncRequest {
  upserts: OperationLabel[];
  deleteIds: string[];
  /** The labels as last loaded; the save is rejected if another user changed them since. */
  baseline?: OperationLabel[];
}

export const DEFAULT_LABEL_COLOR = '#6F68B9';
export const LABEL_NAME_MAX_LENGTH = 30;
/** Letters in any language, numbers, spaces and - _ & / ( ) . (PRD R-3). */
export const LABEL_NAME_PATTERN = /^[\p{L}\p{M}\p{N} \-_&/().]+$/u;
export const LABEL_NAME_LETTER_OR_DIGIT = /[\p{L}\p{N}]/u;
export const MAX_LABELS_PER_LOAD = 5;
export const MAX_ACTIVE_LABELS = 50;

/** Trims and collapses repeated inner spaces; case is kept as typed (PRD R-1, R-5). */
export function normalizeLabelName(name: string): string {
  return (name || '').trim().replace(/\s+/g, ' ');
}

/** A to Z ignoring case (PRD R-6). */
export function compareLabelNames(a: { name: string }, b: { name: string }): number {
  return (a?.name || '').localeCompare(b?.name || '', undefined, {sensitivity: 'base'});
}
